import { axiosGraphQL } from "../api";
import { IS_MOBILE_REGISTERED } from "../graphql/userGraphql";

export const checkMobileRegistration = async (
  mobile,
  request = axiosGraphQL
) => {
  const normalizedMobile = mobile?.trim();

  if (!normalizedMobile) {
    throw new Error("error_invalid_phone_number");
  }

  const response = await request(
    {
      query: IS_MOBILE_REGISTERED,
      variables: { mobile: normalizedMobile },
    },
    { noAuth: true }
  );
  const isRegistered = response.data?.data?.isMobileRegistered;

  if (typeof isRegistered !== "boolean") {
    throw new Error("error_during_login");
  }

  return isRegistered;
};

export const startRegisteredMobileLogin = async (
  mobile,
  sendCode,
  checkRegistration = checkMobileRegistration
) => {
  const isRegistered = await checkRegistration(mobile);

  if (!isRegistered) {
    return { isRegistered: false };
  }

  return {
    isRegistered: true,
    confirmationResult: await sendCode(mobile),
  };
};
